// src/services/dealerVisit.service.js
import api from './api';

const dealerVisitService = {
  // Get dealers dropdown
  getDealers: async (search = '') => {
    try {
      const params = {};
      if (search) params.search = search;
      const response = await api.get('/dealer-visits/dealers', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching dealers:', error);
      throw error;
    }
  },

  // Create dealer visit
  createVisit: async (data) => {
    try {
      const response = await api.post('/dealer-visits', data);
      return response.data;
    } catch (error) {
      console.error('Error creating dealer visit:', error);
      throw error;
    }
  },

  // Get today's visits
  getTodayVisits: async () => {
    try {
      const response = await api.get('/dealer-visits/today');
      return response.data;
    } catch (error) {
      console.error('Error fetching today visits:', error);
      throw error;
    }
  },


// Get all dealer visits (paginated, filterable)
getAllVisits: async (fromDate = '', toDate = '', search = '', page = 1, limit = 20) => {
  try {
    const params = { page, limit };
    if (fromDate) params.fromDate = fromDate;
    if (toDate)   params.toDate   = toDate;
    if (search)   params.search   = search;
    const response = await api.get('/dealer-visits/all', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching all dealer visits:', error);
    throw error;
  }
},
};

export default dealerVisitService;